import React, { useState } from "react";

const dev = ["to Me","about Me","contact Me"];



export default function ShortFilm() {

  return (
    <>  
      <div className="shortFilm">
        <a href="/"><button  className="left-slide"><img src="back_arrow.svg" /><p>Back</p></button></a>
        <h4 className="credit">A ShortFilm By</h4>
        <h4 className="name">Vatsal.R.J.Chourey</h4>
        <h4 className="msg">Video might buffer, download for quality view.</h4>
        <iframe loading="lazy" className="shrtfilm" src="/petalsconv.mp4?autoplay=1&loop=1" />
      </div>
    </>
  );
}